module.exports = __webpack_public_path__ + "img/alexandera-kalcher.ee00c246.jpg";